import type { WaitlistEntry } from "@/types/waitlist";

export function buildWaitlistBookingUrl(
  entry: Pick<WaitlistEntry, "id" | "patientId">,
  slot: { start: Date; locationId?: string | null },
): string {
  const params = new URLSearchParams({
    // The instant, so the form reads it on its location's clock.
    start: slot.start.toISOString(),
    waitlistId: entry.id,
  });
  if (entry.patientId) params.set("patientId", entry.patientId);
  if (slot.locationId) params.set("locationId", slot.locationId);
  return `/check-in/appointment-form/new?${params.toString()}`;
}
